import { OneOfDataNodes, IState, IBoundingBox } from '@studio/domain';
import { getBoundingRectangleOfRotatedBox, getOuterBounds } from '@studio/utils/geom';
import { isGroupDataNode, toFlatElementNodeList } from '../nodes/helpers';
import { getBoundingBoxOfElementWithState } from '../rendering';

export function calculateBoundingBox(nodes: OneOfDataNodes[], state?: IState): IBoundingBox {
    const boxes = nodes
        .map(node => {
            if (isGroupDataNode(node)) {
                return toFlatElementNodeList(node);
            }
            return node;
        })
        .flat()
        .map((node, _, array) => {
            if (array.length === 1) {
                return getBoundingBoxOfElementWithState(node, state, true);
            }
            // Multiple elements selected, include rotations in box size.
            return getBoundingRectangleOfRotatedBox(node);
        });

    return {
        rotationZ: 0,
        ...(boxes.length === 1 ? boxes[0] : getOuterBounds(...boxes))
    };
}
